import { useInfiniteQuery } from 'react-query';
import { useAuth } from '../auth/AuthProvider';
import { getRequestHeaders, vake_api_server_url } from '../requests/helpers';

type PropsSearchResultQuery = {
    data: SearchResult[];
    nextPage: number | undefined;
};
type SearchResultApiResponse = {
    name: string | null;
    mmsi: number;
    imo: number | null;
    createdAt: string;
};
export type SearchResult = {
    name: string;
    mmsi: number;
    imo: number;
    createdAt: Date;
};
export const useVesselNameSearch = (searchInput: string) => {
    const { token } = useAuth();
    const url = `${vake_api_server_url}/search?query=${searchInput}`;
    return useInfiniteQuery<PropsSearchResultQuery, Error>({
        queryKey: ['search', searchInput],
        queryFn: async ({ pageParam = 0 }) => {
            const limit = 5;
            const offset = pageParam * limit;
            const res = await fetch(`${url}&offset=${offset}&limit=${limit}`, {
                credentials: 'include',
                headers: getRequestHeaders(token),
            });
            if (!res.ok) {
                throw new Error(res.statusText);
            }
            if (res.status === 204) {
                return { data: [], nextPage: undefined };
            }
            const apiData = await res.json();
            const hasNextPage = apiData.length === limit;
            return {
                data: apiData.map((item: SearchResultApiResponse) => ({
                    name: item.name || 'N/A',
                    mmsi: item.mmsi,
                    imo: item.imo || 0,
                    createdAt: new Date(item.createdAt),
                })),
                nextPage: hasNextPage ? pageParam + 1 : undefined,
            };
        },
        getNextPageParam: (lastPage) => lastPage.nextPage,
        enabled: !!token && searchInput !== '',
    });
};
